var appSocket = function appSocket(event) {// implement logic
};

export { appSocket };